import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { IMG, scrollToId } from "../content";
import { EASE, MaskReveal } from "./Reveal";

const Hero = () => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const photoY = useTransform(scrollYProgress, [0, 1], ["0%", "16%"]);
  const fade = useTransform(scrollYProgress, [0, 0.75], [1, 0]);

  return (
    <section className="hero" ref={ref} data-testid="hero-section" aria-label="Mindful Athlete introduction">
      <motion.img
        src={IMG.hero}
        alt="Athletes stretching together in a gym beneath the Mindset Is Everything wall"
        className="hero-photo"
        style={reduce ? undefined : { y: photoY }}
        fetchPriority="high"
      />
      <div className="hero-scrim" aria-hidden="true" />
      <motion.div className="hero-content" style={reduce ? undefined : { opacity: fade }}>
        <motion.p
          className="hero-eyebrow"
          initial={reduce ? false : { opacity: 0, y: 14 }}
          animate={reduce ? undefined : { opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25, ease: EASE }}
        >
          Mindset • Movement • Recovery
        </motion.p>
        <h1 className="hero-title">
          <MaskReveal immediate delay={0.35}>Train your body.</MaskReveal>
          <MaskReveal immediate delay={0.5} className="hero-title-italic">
            <em>Train your mind.</em>
          </MaskReveal>
        </h1>
        <motion.p
          className="hero-copy"
          initial={reduce ? false : { opacity: 0, y: 18 }}
          animate={reduce ? undefined : { opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.75, ease: EASE }}
        >
          Helping athletes build mental strength, move better, recover smarter and perform with confidence.
        </motion.p>
        <motion.div
          className="hero-actions"
          initial={reduce ? false : { opacity: 0, y: 18 }}
          animate={reduce ? undefined : { opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.9, ease: EASE }}
        >
          <button type="button" className="btn btn-primary btn-on-dark" onClick={() => scrollToId("coaching")} data-testid="hero-coaching-cta">
            Explore 1:1 Coaching <ArrowUpRight size={16} />
          </button>
          <button type="button" className="btn btn-outline-dark" onClick={() => scrollToId("community")} data-testid="hero-community-cta">
            Join the Community <ArrowDownRight size={16} />
          </button>
        </motion.div>
      </motion.div>
      <motion.button
        type="button"
        className="hero-scrollcue"
        onClick={() => scrollToId("about")}
        aria-label="Scroll to About section"
        data-testid="hero-scroll-cue"
        initial={reduce ? false : { opacity: 0 }}
        animate={reduce ? undefined : { opacity: 1 }}
        transition={{ delay: 1.4, duration: 0.8 }}
      >
        <span />
      </motion.button>
    </section>
  );
};

export default Hero;
